const React = require("react");
const RootElement = require("./src/components/root-element").default;

exports.wrapRootElement = ({ element }) =>
  React.createElement(RootElement, null, element);

exports.onClientEntry = function onClientEntry() {
  // Defer scriptwrapper until after the browser is idle so third-party
  // analytics (Yandex Metrica, etc.) fire when the DOM is fully ready.
  // if (document.readyState === "complete") {
  //   scheduleScriptwrapper();
  // } else {
  //   window.addEventListener("load", scheduleScriptwrapper, { once: true });
  // }

  window.addEventListener("unhandledrejection", ({ reason }) => {
    const isChunkError =
      reason &&
      (reason.name === "ChunkLoadError" ||
        /Loading chunk \d+ failed/i.test(reason.message || "") ||
        /page resources for .* not found/i.test(reason.message || ""));

    if (isChunkError) {
      // Prevent infinite reload loops: only reload once every 30 seconds.
      const RELOAD_KEY = "__chunkErrReload";
      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - lastReload > 30000) {
        sessionStorage.setItem(RELOAD_KEY, Date.now().toString());
        window.location.reload();
      }
    }
  });
};
